import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import _size from 'lodash/size'
// Components
import ItemTimeline from './ItemTimeline'
import { ItemList } from '~2023/components/ContainerCard'
import { ItemCard } from '~2023/components/ContainerCard'
import { ItemCardFeature } from '~2023/components/ContainerCard'
import { ItemCardFeatureRecap } from '~2023/components/ContainerCard'
import { getFandom } from '~2023/utils'
const filterSelector = (state) => state.filter

const ItemContainer = ({ items, location }) => {
  const {
    data: {
      isFiltered,
      sort: filterSort,
      viewType: filterViewType,
      id: filterId,
      title: filterTitle,
    },
  } = useSelector(filterSelector)

  /**
   * @note
   * Show Features and a Feature Recap in `card` mode
   */
  const flagFeature = 'card' === filterViewType && !isFiltered

  /**
   * @note
   * Used to generate Feature Recap based off of existing Features
   */

  const itemsSize = _size(items)
  const featuresRecap = []

  useEffect(() => {
    if (location && location.state && location.state.activeDetail) {
      const card = document.getElementById(
        `card-${location.state.activeDetail}`
      )
      if (card && 'card' === filterViewType) {
        card.parentNode.parentNode.focus()
      } else if (card && 'list' === filterViewType) {
        card.parentNode.focus()
      }
    }
    return () => {
      if (location && location.state && location.state.activeDetail) {
        location.state.activeDetail = null
      }
    }
  }, [location, filterViewType])

  const itemsSorted = 'rank' !== filterSort ? items.reverse() : items

  return (
    <React.Fragment>
      <div
        itemScope
        itemType="https://schema.org/Blog"
        style={{
          alignItems: 'center',
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          margin: '0 auto',
          maxWidth: '1176px',
        }}
      >
        {itemsSorted.map((item, index) => {
          const itemData = item.isRecap
            ? { ...item }
            : getFandom({
                filterId,
                filterTitle,
                isFiltered,
                item: item.node,
              })

          flagFeature &&
            itemData.hasFeature &&
            featuresRecap.push({
              id: itemData.id,
              linkExternal: itemData.feature.frontmatter.linkExternal,
              title: itemData.feature.frontmatter.title,
            })

          return (
            <React.Fragment key={`card-fandom-overall-${index}`}>
              {'card' === filterViewType ? (
                <div className="cardItem" key={`card-${index}`}>
                  <ItemCard
                    dataIndex={index}
                    item={itemData}
                    filterSort={filterSort}
                    totalItems={itemsSize}
                  />
                </div>
              ) : (
                <div className="listItem" key={`card-${index}`}>
                  <ItemList
                    dataIndex={index}
                    item={itemData}
                    filterSort={filterSort}
                    totalItems={itemsSize}
                  />
                </div>
              )}
              {flagFeature && itemData.hasFeature && (
                <div
                  className="cardItem cardFeature"
                  key={`card-feature-${index}`}
                >
                  <ItemCardFeature dataIndex={index} item={itemData} />
                </div>
              )}
              {/* {flagFeature && itemsSize - 1 === index && (
                <ItemCardFeatureRecap dataIndex={index} item={featuresRecap} />
              )} */}
            </React.Fragment>
          )
        })}
      </div>
      {!isFiltered && <ItemTimeline location={location} />}
    </React.Fragment>
  )
}

export default ItemContainer
